var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgMobileShareLink = function SvgMobileShareLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.217 9.896c-.534 0-1.012.21-1.378.54L4.83 7.52a2.3 2.3 0 0 0 .062-.492 2.3 2.3 0 0 0-.063-.492l4.955-2.888a2.106 2.106 0 0 0 3.542-1.54A2.106 2.106 0 0 0 11.217 0a2.106 2.106 0 0 0-2.109 2.108c0 .17.028.33.064.492L4.217 5.49a2.106 2.106 0 0 0-3.542 1.54 2.106 2.106 0 0 0 3.542 1.538l5.004 2.924a1.983 1.983 0 0 0-.056.457c0 1.131.92 2.052 2.052 2.052 1.131 0 2.052-.92 2.052-2.052 0-1.132-.92-2.052-2.052-2.052Z",
    fill: "#fff"
  })));
};

export default SvgMobileShareLink;